<template>
  <div class="px-4 pt-0 mt-0">
    <v-text-field
      style="width: 30%;"
      v-if="!loading"
      v-model="search"
      label="Search"
      prepend-icon="mdi-magnify"
      clearable
      class="mb-2"
      hide-details
    ></v-text-field>

    <v-data-table
      v-if="!loading"
      :headers="headers"
      :items="filteredBookings"
      :loading="loading"
      class="elevation-1"
      :rows-per-page-items="[100, 500, 1000]"
      :pagination.sync="pagination"
    >
      <template slot="items" slot-scope="props">
        <tr v-if="props.item !== null" @click="onRowClick(props.item)" style="cursor: pointer;">
          <td>{{ props.item.id }}</td>
          <td>{{ props.item.name }}</td>
          <td>{{ formatDate(props.item.start) }}</td>
          <td>{{ formatDate(props.item.end) }}</td>
          <td>{{ props.item.topic }}</td>
          <td>{{ props.item.PIN }}</td>
          <td>
            <v-icon small :color="props.item.active ? 'success' : 'error'">
              {{
                props.item.active ? "mdi-check-circle" : "mdi-close-circle"
              }}
            </v-icon>
          </td>
          <td>
            {{ props.item.participants ? props.item.participants.length : 0 }}
          </td>
          <td>{{ props.item.createdBy }}</td>
          <td>{{ formatDate(props.item.createdOn) }}</td>
        </tr>
      </template>
    </v-data-table>

    <div v-else class="text-center">
      <v-progress-linear indeterminate color="primary"></v-progress-linear>
    </div>

    <v-dialog v-model="eventDialog" max-width="650">
      <conference-room-booking
        v-if="selectedEvent"
        :selected-event="selectedEvent"
        :processing="processing"
        @close="eventDialog = false"
        @delete="$emit('delete')"
        @edit="$emit('edit')"
      ></conference-room-booking>
    </v-dialog>
  </div>
</template>

<script>
import ConferenceRoomBooking from "./ConferenceRoomBooking.vue";

export default {
  name: "ConferenceRoomBookings",
  components: { ConferenceRoomBooking },
  props: {
    events: {
      type: Array,
      required: true,
    },
    processing: Boolean,
  },
  data() {
    return {
      loading: false,
      eventDialog: false,
      daleteEventDialog: false,
      selectedEvent: null,
      search: "",
      pagination: { sortBy: "id", descending: false },
      headers: [
        { text: "ID", value: "bookingID" },
        { text: "Name", value: "name" },
        { text: "Start Time", value: "startTime" },
        { text: "End Time", value: "endTime" },
        { text: "Topic", value: "topic" },
        { text: "PIN", value: "pin" },
        { text: "Active", value: "isActive" },
        { text: "Participants", value: "participants", sortable: false },
        { text: "Created By", value: "createdBy" },
        { text: "Created On", value: "createdOn" },
      ],
    };
  },
  watch: {
    events(newEvents) {
      if (this.selectedEvent) {
        const updated = newEvents.find((e) => e.id === this.selectedEvent.id);
        if (updated) {
          this.selectedEvent = updated;
        } else {
          this.eventDialog = false;
          this.selectedEvent = null;
        }
      }
    },
  },

  computed: {
    filteredBookings() {
      if (!this.search) return this.events;
      const s = this.search.toLowerCase();
      return this.events.filter((b) =>
        [b.name, b.topic, b.pin, b.createdBy].some(
          (v) => v && v.toLowerCase().includes(s)
        )
      );
    },
  },

  created() {},

  methods: {
    formatDate(dateStr) {
      if (!dateStr) return "";
      return new Date(dateStr).toLocaleString();
    },
    onRowClick(booking) {
        console.log(booking);
      this.selectedEvent = booking;
      this.$emit("selectedEvent", booking);
      this.eventDialog = true;
    },
  },
};
</script>
